import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=5f4a1096&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Orders.vue?vue&type=style&index=1&id=5f4a1096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a1096",
  null
  
)

export default component.exports